module.exports = __webpack_public_path__ + "static/media/psdUploader.3636e66a.png";